import _Share from "@mui/icons-material/Share";
import React from 'react';
import { ButtonContainer, IconButtonLabel, IconButtonWrapper, withDropShadow } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import { useShare } from 'app/components/socialShare/useShare';
import { SocialShareButtons } from 'app/components/socialShare/socialShareButtons';
import { useLocation } from 'react-router';
const StyledShare = withDropShadow(_Share);
const VideoShareButton = _ref => {
  let {
    video
  } = _ref;
  const {
    open,
    handleShare,
    handleShareClose
  } = useShare('video', video.matchPlaylist, video.title);
  const location = useLocation();
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "VideoShareButton",
    "data-sentry-source-file": "VideoShareButton.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: handleShare,
    noMargin: true,
    title: "Teilen",
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "VideoShareButton.tsx"
  }, /*#__PURE__*/React.createElement(StyledShare, {
    "data-sentry-element": "StyledShare",
    "data-sentry-source-file": "VideoShareButton.tsx"
  })), /*#__PURE__*/React.createElement(IconButtonLabel, {
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "VideoShareButton.tsx"
  }, "Teilen"), /*#__PURE__*/React.createElement(SocialShareButtons, {
    url: "https://www.fupa.net".concat(location.pathname),
    text: video.title,
    open: open,
    onClose: handleShareClose,
    "data-sentry-element": "SocialShareButtons",
    "data-sentry-source-file": "VideoShareButton.tsx"
  }));
};
export default VideoShareButton;